module.exports = __webpack_public_path__ + "img/secondary_11x3_z18.f42a26c4.svg";